import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { TaraCard, TaraCardHeader, TaraCardTitle, TaraCardContent } from '../components/ui/TaraCard';
import TaraButton from '../components/ui/TaraButton';
import BottomNav from '../components/BottomNav';

const ProfileNew = () => {
  const navigate = useNavigate();
  const userName = localStorage.getItem('userName') || 'User';
  const birthData = JSON.parse(localStorage.getItem('birthData') || '{}');
  const birthCoords = JSON.parse(localStorage.getItem('birthCoordinates') || '{}');
  
  return (
    <div className="min-h-screen bg-stone-50 pb-24">
      {/* Header */}
      <div className="bg-cosmic-dawn px-5 pt-12 pb-8">
        <div className="max-w-2xl mx-auto text-center">
          <div className="w-24 h-24 bg-cosmic-200 rounded-full mx-auto mb-4 flex items-center justify-center text-4xl">
            👤
          </div>
          <h1 className="font-serif text-2xl font-medium text-stone-900">
            {userName}
          </h1>
          <p className="text-sm text-stone-600 mt-1">
            {userName.toLowerCase().replace(/\s+/g, '')}@taraanaya.ai
          </p>
        </div>
      </div>
      
      {/* Content */}
      <div className="px-5 py-6 max-w-2xl mx-auto space-y-6 -mt-4">
        {/* Birth Details Card */}
        <TaraCard>
          <TaraCardHeader>
            <div className="flex items-center justify-between">
              <TaraCardTitle>Birth Details</TaraCardTitle>
              <button className="text-sm text-cosmic-600 hover:text-cosmic-700 font-medium transition-colors">
                Edit
              </button>
            </div>
          </TaraCardHeader>
          <TaraCardContent>
            <div className="space-y-2 text-sm text-stone-700">
              <p>📅 {birthData.date || 'Not set'}</p>
              <p>🕐 {birthData.time || 'Not set'}</p>
              <p>📍 {birthCoords.place_name || 'Not set'}</p>
            </div>
          </TaraCardContent>
        </TaraCard>
        
        {/* Settings Card */}
        <TaraCard>
          <TaraCardHeader>
            <TaraCardTitle>Settings</TaraCardTitle>
          </TaraCardHeader>
          <TaraCardContent>
            <div className="space-y-3">
              {[
                { label: 'Notifications', value: 'On' },
                { label: 'Calm Mode', value: 'Off' },
                { label: 'Language', value: 'English' },
              ].map((setting) => (
                <button
                  key={setting.label}
                  className="w-full flex items-center justify-between p-3 hover:bg-stone-50 rounded-lg transition-colors"
                >
                  <span className="text-sm text-stone-700">{setting.label}</span>
                  <div className="flex items-center gap-2">
                    <span className="text-sm text-stone-500">{setting.value}</span>
                    <ChevronRight className="w-5 h-5 text-stone-400" />
                  </div>
                </button>
              ))}
            </div>
          </TaraCardContent>
        </TaraCard>
        
        {/* Actions */}
        <div className="space-y-3">
          <TaraButton
            variant="secondary"
            size="lg"
            className="w-full"
            onClick={() => {
              if (window.confirm('Are you sure you want to reset all data?')) {
                // Preserve device ID for login method locking
                const deviceId = localStorage.getItem('device_id');
                const taraanayaDeviceId = localStorage.getItem('taraanaya_device_id');
                const pastStoryViewed = localStorage.getItem('past_story_viewed');
                const freeStoryUsed = localStorage.getItem('free_story_used');
                localStorage.clear();
                if (deviceId) localStorage.setItem('device_id', deviceId);
                if (taraanayaDeviceId) localStorage.setItem('taraanaya_device_id', taraanayaDeviceId);
                if (pastStoryViewed) localStorage.setItem('past_story_viewed', pastStoryViewed);
                if (freeStoryUsed) localStorage.setItem('free_story_used', freeStoryUsed);
                navigate('/');
              }
            }}
          >
            Reset Data (For Testing)
          </TaraButton>
          
          <TaraButton
            variant="ghost"
            className="w-full text-red-600 hover:text-red-700"
            onClick={() => {
              // Preserve device ID for login method locking
              const deviceId = localStorage.getItem('device_id');
              const taraanayaDeviceId = localStorage.getItem('taraanaya_device_id');
              const pastStoryViewed = localStorage.getItem('past_story_viewed');
              const freeStoryUsed = localStorage.getItem('free_story_used');
              localStorage.clear();
              if (deviceId) localStorage.setItem('device_id', deviceId);
              if (taraanayaDeviceId) localStorage.setItem('taraanaya_device_id', taraanayaDeviceId);
              if (pastStoryViewed) localStorage.setItem('past_story_viewed', pastStoryViewed);
              if (freeStoryUsed) localStorage.setItem('free_story_used', freeStoryUsed);
              navigate('/login');
            }}
          >
            Sign Out
          </TaraButton>
        </div>
      </div>
      
      <BottomNav active="profile" />
    </div>
  );
};

export default ProfileNew;